module.exports = __webpack_public_path__ + "img/logo.997d8f24.png";